import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-overlay-content',
  templateUrl: './map-overlay-content.component.html',
  styleUrls: ['./map-overlay-content.component.scss']
})
export class MapOverlayContentComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
